import React, { useState } from 'react';
import css from './FilterSidebar.module.css';
import { FormattedMessage } from 'react-intl';
import { brandIndustriesOptions } from '../../../util/enums';
import { Icons } from '../../../components';
import classNames from 'classnames';

const IndustryFilterSection = ({
  selectedValues,
  paramKey,
  handleCheckboxChange,
  handleClearFilter,
  isBlackBgFilter,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Sort options alphabetically by label, then filter based on the search term (case-insensitive)
  const filteredOptions = brandIndustriesOptions
    .sort((a, b) => a.label.localeCompare(b.label))
    .filter(opt => opt.label.toLowerCase().includes(searchTerm.toLowerCase()));

  return (
    <div className={css.filterSection}>
      <div className={classNames(isBlackBgFilter ? css.blackBgFilter : null, css.sectionHeader)}>
        <h3>
          <FormattedMessage id="FilterCategories.interests" />
        </h3>
        <button
          className={css.clearButton}
          onClick={() => {
            handleClearFilter(paramKey);
            setSearchTerm('');
          }}
        >
          <FormattedMessage id="FilterCategories.clear" />
        </button>
      </div>
      {/* Search Input */}

      <div className={css.searchKeywordSec}>
        <Icons name="search" className={css.searchIcon} />
        <input
          type="text"
          className={css.searchInput}
          placeholder="Search industries..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          name="industry"
        />
      </div>
      <div className={css.scrollable}>
        {filteredOptions.map(opt => {
          const optionKey = opt.value;
          const isChecked = selectedValues.includes(optionKey);
          return (
            <label key={optionKey} className={css.checkboxLabel}>
              <input
                type="checkbox"
                value={opt.value}
                checked={isChecked}
                onChange={e => {
                  handleCheckboxChange(e, paramKey);
                  setSearchTerm('');
                }}
                name="industry"
              />
              <span>{opt.label}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default IndustryFilterSection;
